"use client";

import * as React from "react";

import { Editor, useCurrentEditor } from "@tiptap/react";

// ts-unused-exports:disable-next-line
export function useTiptapEditor(providedEditor?: Editor | null): Editor | null {
  const { editor: coreEditor } = useCurrentEditor();
  return React.useMemo(
    () => providedEditor || coreEditor,
    [providedEditor, coreEditor],
  );
}
